import { useEffect, useMemo, useState } from 'react';
import '../../../styles.scss';
import { Tabs, Pagination, ConfigProvider, PaginationProps } from 'antd';

import { SettingOutlined, EyeOutlined, EditOutlined, FileAddOutlined } from '@ant-design/icons';
import { TabsProps } from 'antd/lib';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../../../components/NoDataTable';
import { formatNumber } from '../../../../../services/mixin';
import viVN from "antd/locale/vi_VN";
import { FlattenedField } from '../../../../CustomersV2/indexV2';
import { FieldsUpdate, getListCustomerComplaints, getListFieldsByCustomer, IComplaintDetail, ICustomer, ListField, updateFieldUser } from '../../../../../api/Customer_V2/customerApi_V2';
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { ColumnKey } from '../../../../Customers/Tabs/CarListCardClone';
import useLoading from '../../../../../hook/useLoading';
import useToast from '../../../../../hook/useToast';
import { useSelector } from 'react-redux';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { generateColumnsFromCodesAgGridReactRecordCar } from '../../ServiceRecords/ContactInformation';
import useDebounce from '../../../../../hook/useDebounce';
import { CustomLoadingOverlayTable, dataPagination, flattenFields } from '../../../../../until';
import ServiceRecordFeilds from '../../ServiceRecords/Components/ServiceRecordFeilds';
import TabSupportHistoryTabDetail from './Components/TabSupportHistoryTabDetail';
import { ColDef } from 'ag-grid-community';
import ModalAddSupportHistory from './Components/ModalAddSupportHistory';
import ModalDetailSupportHistory from './Components/ModalDetailSupportHistory';
import ModalUpdateSupportHistory from './Components/ModalUpdateSupportHistory';
import { FIELDTYPE, NO_VIEW } from '../../../../../services/data';
import useThrottle from '../../../../../hook/useThrottle';

type PaginationKey = "info";
interface IDataFilterActive {
  info: FlattenedField[];
}

interface IDataFilterNoActive {
  info: ListField[];
}

const EMPTY_GROUP = {
  info: [],
};

interface Props {
  loadingTable: boolean
  isModalSupportHistoryAdd: boolean
  isModalSupportHistoryDetail: boolean
  isModalSupportHistoryUpdate: boolean
  infoSupportHistoryDetail: IComplaintDetail | undefined

  dataFieldsActive: FlattenedField[]
  idCustomer?: number
  data: ICustomer[]
  pagination: IPagination
  onPaginationChange: (page: number, pageSize: number) => void
  openModalDetail: (value: number) => void
  openModalUpdate: (value: number) => void

  setIsModalSupportHistoryAdd: (e: boolean) => void
  setIsModalSupportHistoryDetail: (e: boolean) => void
  setIsModalSupportHistoryUpdate: (e: boolean) => void

  resultFormSubmitSupportHistory: (iSsuccess: boolean, message?: string | undefined) => void
}

const TabSupportHistory: React.FC<Props> = ({
  loadingTable,
  isModalSupportHistoryAdd,
  isModalSupportHistoryDetail,
  isModalSupportHistoryUpdate,
  infoSupportHistoryDetail,
  dataFieldsActive, pagination,
  idCustomer, data,
  onPaginationChange,
  openModalDetail, openModalUpdate,
  setIsModalSupportHistoryAdd,
  setIsModalSupportHistoryDetail,
  setIsModalSupportHistoryUpdate,
  resultFormSubmitSupportHistory
}) => {
  useEffect(() => {
    gListFieldsActive()
  }, [])
  const pushLoading = useLoading()
  const pushToast = useToast();
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const { id, unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const [isSettingShow, setSettingShow] = useState(false)
  const [loadingTableDetail, setLoadingTableDetail] = useState(false)

  const [activeTab, setActiveTab] = useState<PaginationKey>("info");
  const [dataFieldsSupportHistoryActive, setDataFieldsSupportHistoryActive] = useState<IDataFilterActive>(EMPTY_GROUP);
  const [dataFieldsSupportHistoryNoActive, setDataFieldsSupportHistoryNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
    info: { current: 1, pageSize: 10, total: 0 },
  });
  const [loadedTabs, setLoadedTabs] = useState<Record<PaginationKey, boolean>>({
    info: false,
  });

  const [selectId, setSelectId] = useState<number>()
  const [infoSupportHistory, setInfoSupportHistory] = useState<ICustomer[]>([]);

  //#region Cấu hình cột

  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    headerComponentParams: {
      template: '<span class="custom-page-css w-full flex items-center justify-center">Hành động</span>'
    },
    cellRenderer: (params: any) => {
      const { id } = params?.data
      return (
        <div className='d-flex gap-2 justify-center align-center  h-full px-1'>

          <EyeOutlined
            className='text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer'
            onClick={(e) => {
              e.stopPropagation(); // 🔴 chặn click lan lên row
              const currentId = params.data?.id;
              if (!currentId) {
                pushToast("không tồn tại id!", 'error')
                return
              }
              if (currentId === selectId) {
                params.node.setSelected(false); // ❌ bỏ chọn
                setSelectId(undefined);         // reset
                return;
              }

              params.node.setSelected(true);    // ✅ chọn mới
              setSelectId(currentId);
            }}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => openModalUpdate(id)}
          />
          <FileAddOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => openModalDetail(id)}
          />
        </div >

      )
    },
  }

  const memoizedColumnDefs = useMemo(() => {
     return generateColumnsFromCodesAgGridReactRecordCar(
      columnsMapShow,
      dataFieldsActive,
      actionColumn, // actionColumn
      undefined, // onToggleStatus
      { setDataFilterList: () => { } }, // headerActions
      undefined, // listFilterIcon
      undefined, // dataFilterList
      idCustomer, // customerId
      ["contact_name"] // listFieldCodeLink
    );
    // return generateColumnsFromCodesAgGridReactRecordCar(
    //   columnsMapShow, dataFieldsActive, actionColumn,
    //   () => { }
    // );
  }, [columnsMapShow, dataFieldsActive, selectId]);

  const tableData = useMemo(() => {
    return data.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, [data]);

  useEffect(() => {
    const codes = dataFieldsActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFieldsActive]);
  //#endregion

  const gListFieldsActive = async () => {
    const [supportHistoryTabDetailRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SupportHistoryDetail, 1),
      ]);
    const flattenedFieldsContactInformation = flattenFields(supportHistoryTabDetailRes?.data ?? []);

    setDataFieldsSupportHistoryActive({
      info: flattenedFieldsContactInformation,

    });

    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    const [supportHistoryTabDetailNoActiveRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SupportHistoryDetail, 0),
      ]);

    setDataFieldsSupportHistoryNoActive({
      info: supportHistoryTabDetailNoActiveRes?.data ?? [],
    })
  };


  const gListDetail = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    if (!idCustomer || !selectId) {
      setInfoSupportHistory([]);
      return;
    }
    setLoadingTableDetail(true)
    const result = await getListCustomerComplaints(
      idCustomer, unitTemp, permittedCategoryCarIds,
      selectId, pageSize, pageCurent
    )
    if (result?.status) {
      setInfoSupportHistory(result.data)
      setPaginationMap(prev => ({
        ...prev,
        info: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      info: true,
    }));
    setLoadingTableDetail(false)
  }, 1000)

  const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
    let result: any;
    const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));
    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );
    const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

    switch (activeTab) {

      case 'info': {
        result = await updateFieldUser(id, FIELDTYPE.SupportHistoryDetail, undefined, listActiveFields)
        break;
      }

      default:
        break;
    }

    if (result?.status) {
      pushToast(result?.message, "success")
      setSettingShow(false)

      if (dataFilterActive && dataFilterNoActive) {
        setDataFieldsSupportHistoryActive(prev => ({
          ...prev,
          [activeTab]: dataFilterActive ?? [],
        }));

        setDataFieldsSupportHistoryNoActive(prev => ({
          ...prev,
          [activeTab]: dataFilterNoActive ?? [],
        }));
      }

    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)

  const onPaginationChangeTab: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    switch (activeTab) {
      case "info": {
        gListDetail(pageNumber, pageSize)
        break;
      }

      default:
        break;
    }
  }

  const handleResultFormSubmit = (isSuccess: boolean, message?: string) => {
    resultFormSubmitSupportHistory(isSuccess, message);

    if (isSuccess && infoSupportHistoryDetail?.id === selectId) {
      gListDetail()
    }
  };

  useEffect(() => {
    if (!selectId) return;

    // 1️⃣ RESET
    setInfoSupportHistory([]);

    setLoadedTabs({
      info: false,
    });

    setPaginationMap({
      info: { current: 1, pageSize: 10, total: 0 },

    });

    // 2️⃣ GỌI API ĐÚNG TAB
    switch (activeTab) {
      case "info":
        gListDetail();
        break;
      default:
        break
    }
  }, [selectId]);

  useEffect(() => {
    if (!selectId) return;

    switch (activeTab) {
      case "info":
        if (!loadedTabs.info) gListDetail();
        break;
      default:
        break
    }
  }, [activeTab]);
  return (
    <>
      <ModalAddSupportHistory
        isOpen={isModalSupportHistoryAdd}
        idCustomer={idCustomer}
        resultFormSubmit={handleResultFormSubmit}
        closeModal={setIsModalSupportHistoryAdd}
      />

      <ModalDetailSupportHistory
        isOpen={isModalSupportHistoryDetail}
        idCustomer={idCustomer}
        infoSupportHistoryDetail={infoSupportHistoryDetail}
        closeModal={setIsModalSupportHistoryDetail}
      />

      <ModalUpdateSupportHistory
        isOpen={isModalSupportHistoryUpdate}
        idCustomer={idCustomer}
        infoSupportHistory={infoSupportHistoryDetail}
        resultFormSubmit={resultFormSubmitSupportHistory}
        closeModal={setIsModalSupportHistoryUpdate}
      />
      {
        isSettingShow ?
          <ServiceRecordFeilds
            isSettingShow={isSettingShow}
            type={0}
            dataFilterActive={dataFieldsSupportHistoryActive[activeTab]}
            dataFilterNoActive={dataFieldsSupportHistoryNoActive[activeTab]}

            onSaveVisibleFields={onSaveVisibleFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      }
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">
        <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3">
          <div className="ag-theme-alpine custom-table-ag custom-css-table"
            style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
          >
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={tableData}
              columnDefs={memoizedColumnDefs}
              rowHeight={55}
              overlayNoRowsTemplate={NodataTable}
              loading={loadingTable}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              // onGridReady={(params) => {
              //   params.api.sizeColumnsToFit();
              // }}

              /* Selection – CHỈ CHO PHÉP SELECT BẰNG CODE */
              rowSelection="single"
              suppressRowClickSelection={true}

              /* Performance */
              suppressColumnVirtualisation={true}
              suppressRowVirtualisation={false}
              enableCellTextSelection={true}
              ensureDomOrder={true}
              debounceVerticalScrollbar={true}
              suppressScrollOnNewData={true}
              suppressDragLeaveHidesColumns={true}

              /* Scroll */
              rowBuffer={20}
              maxBlocksInCache={10}
              infiniteInitialRowCount={1000}
            />
          </div>
          <ConfigProvider
            locale={viVN}
          >
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() =>
                  `Tổng cộng ${dataPagination(
                    pagination.total,
                    pagination.pageSize,
                    pagination.current
                  ).totalPage} trang`
                }
                className="rs-pagination"
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>

        </div>

        {/* {
          selectId ? ( */}
        <div
          className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative"
        >
          <Tabs
            className='w-full'
            defaultActiveKey="1"
            activeKey={activeTab}

            items={[
              {
                key: 'info',
                label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
                children:
                  <TabSupportHistoryTabDetail
                    loadingTableDetail={loadingTableDetail}
                    dataFieldsActive={dataFieldsSupportHistoryActive.info}
                    pagination={paginationMap.info}
                    data={infoSupportHistory}

                    onPaginationChange={onPaginationChange}

                  />
                ,
              },
            ]}
          />
          <div className="custom-page-css absolute top-4 right-0">
            <div className='settingCol'>
              <div className='ctr-col-setting'
                onClick={() => setSettingShow(true)}
              >
                <SettingOutlined />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TabSupportHistory